var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.client || !_vm.isAllowed)?_c('span',[_vm._v(_vm._s(_vm.name))]):_c('router-link',{attrs:{"to":{name: 'client', params: {id: _vm.id}}}},[_c('span',[_vm._v(_vm._s(_vm.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }